export { default } from './AttendeesModal';
